import e from 'express';
import { Tag } from '../models/Product';

const translateTag = (tag: Tag) => {
  switch (tag) {
    case Tag.New:
      return 'Nowość';
    case Tag.Sale:
      return 'Wyprzedaż';
    case Tag.Bestseller:
      return 'Bestseller';
    case Tag.Recommended:
      return 'Polecane';
    default:
      return tag;
  }
};

export default translateTag;
